<template>
  <v-row justify="end" align="end" no-gutters style="height:100%">
    <v-col cols="12" lg="12" xs="12">
      <!-- <v-row justify="end" align="end" no-gutters class="my-2"> -->
      <v-layout row wrap justify-end class="pa-1">
        <v-flex xs12 v-if="product.promo == 1 || product.favorite == 1">
          <v-layout row wrap justify-center class="pa-1">
            <v-flex v-if="product.promo == 1">
              <v-sheet
                v-if="product.promo == 1"
                class="white--text mx-auto pa-1"
                color="orange"
              >{{promotionText}}</v-sheet>
            </v-flex>
            <v-flex v-if="product.favorite == 1">
              <v-sheet
                v-if="product.favorite == 1"
                class="white--text mx-auto pa-1"
                color="favourites"
              >Favourite</v-sheet>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- <v-col cols="12" lg="4" xs="4" v-if="boxPrice > 0"> -->
        <v-flex v-if="boxPrice > 0">
          <!-- <v-row justify="end" align="end" no-gutters> -->
          <!-- <v-col cols=w"12" xs="12" class="px-1"> -->
          <div style="text-align: start;">Box</div>
          <!-- </v-col> -->
          <!-- <v-col cols="12" xs="12" class="px-0" style="font-weight:bold"> -->
          <div style="text-align: start;">
            <b>£{{boxPriceDisplay}}</b>
          </div>
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-flex>
        <!-- </v-col> -->

        <!-- <v-col cols="12" lg="4" xs="4" v-if="kiloPrice > 0"> -->
        <v-flex v-if="kiloPrice > 0">
          <!-- <v-row justify="end" align="end" no-gutters> -->
          <!-- <v-col cols="12" xs="12" class="px-1"> -->
          <div style="text-align: start;">Kilo</div>
          <!-- </v-col> -->
          <!-- <v-col cols="12" xs="12" class="px-0" style="font-weight:bold"> -->
          <div style="text-align: start;">
            <b>£{{kiloPriceDisplay}}</b>
          </div>
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-flex>
        <!-- </v-col> -->

        <!-- <v-col cols="12" lg="4" xs="4" v-if="eachPrice > 0"> -->
        <v-flex v-if="eachPrice > 0">
          <!-- <v-row justify="end" align="end" no-gutters> -->
          <!-- <v-col cols="12" xs="12" class="px-1"> -->
          <div style="text-align: start;">Each</div>
          <!-- </v-col> -->
          <!-- <v-col cols="12" xs="12" class="px-0" style="font-weight:bold"> -->
          <div style="text-align: start;">
            <b>£{{eachPriceDisplay}}</b>
          </div>
          <!-- </v-col> -->
          <!-- </v-row> -->
        </v-flex>
        <!-- </v-col> -->
      </v-layout>
      <!-- </v-row> -->
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    product: {}
  },
  data() {
    return {
      tags: null
    };
  },
  computed: {
    boxPrice() {
      return parseFloat(this.product.box_price).toFixed(2);
    },
    kiloPrice() {
      return parseFloat(this.product.kilo_price).toFixed(2);
    },
    eachPrice() {
      return parseFloat(this.product.each_price).toFixed(2);
    },

    boxPriceDisplay() {
      return parseFloat(this.product.box_price).toFixed(2);
    },

    kiloPriceDisplay() {
      return parseFloat(this.product.kilo_price).toFixed(2);
    },

    eachPriceDisplay() {
      if (
        !this.$store.getters.retrieveIsCncCustomer &&
        !this.$store.getters.retrieveIsCashCustomer &&
        parseInt(this.product.catch_weight_flag) == 2
      ) {
        return parseFloat(this.product.kilo_price).toFixed(2) + "/kg";
      } else {
        return parseFloat(this.product.each_price).toFixed(2);
      }
    },

    promotionText() {
      let promotionString = "Promotion";
      if (this.$store.getters.retrieveAllConfigs.promo_btn_text && this.$store.getters.retrieveAllConfigs.promo_btn_text != "") {
          promotionString = this.$store.getters.retrieveAllConfigs.promo_btn_text;
      }

      if (this.$store.getters.retrieveAllConfigs.promo_showname) {
        if (
          parseInt(this.$store.getters.retrieveAllConfigs.promo_showname) == 1
        ) {
          promotionString += ": " + this.product.prom_name;
        }
      }

      return promotionString;
    }
  }
};
</script>

<style lang="sass" scoped>
*
  font-size: 14px
  text-align: center
</style>